/* eslint-disable react/jsx-no-target-blank */
import React, { useState, useEffect } from "react"

import axios from "axios"
import { v4 } from 'uuid';

import { whatsAppShare } from "../../utils/whatsappshare"

const MAX_SEARCH_RESULTS = 12
const WHATSAPP_SHARE_LINK = whatsAppShare(
  `*VIT Class WhatsApp Group Links List*\nhttps://vitspot.com/class-groups/`
)

const ClassGroups = () => {
  const [groups, setGroups] = useState([])
  const [userSearchInput, setUserSearchInput] = useState("")
  const [filteredGroups, setFilteredGroups] = useState([])

  const fetchWhatsappGroups = async () => {
    const { data } = await axios.get(
      "https://services.vitspot.com/class-groups/"
    )
    setGroups(data)
  }

  useEffect(() => {
    fetchWhatsappGroups()
  }, [])

  useEffect(() => {
    const updateSearchResults = () => {
      const newFilteredGroups = groups.filter(({ courseName, facultyName }) => {
        const searchKey = `${courseName}-${facultyName}`
        // console.log(searchKey);
        // console.log(searchKey.toLowerCase(),userSearchInput.toLowerCase())
        return searchKey.toLowerCase().includes(userSearchInput.toLowerCase())
      })
      setFilteredGroups(newFilteredGroups)
    }

    updateSearchResults()
  }, [groups, userSearchInput])

  const updateUserSearchInput = input => {
    setUserSearchInput(input)
    // console.log(filteredGroups)
  }

  return (
    <>
      <div>
        <div className="control mb-6">
          <a
            href="https://go.vitspot.com/f19"
            target="_blank"
            className="button is-dark mb-2 mr-2"
          >
            <span className="icon is-small">
              <i className="fas fa-plus" />
            </span>
            <span>Add Your Group</span>
          </a>
          <a
            href="https://www.instagram.com/vitspotplus/"
            className="button is-danger has-text-white mb-4 mr-2"
            target="_blank"
          >
            Memes/Placement Tips
          </a>
          <a
            href="https://www.instagram.com/vitspot/"
            className="button is-danger has-text-white mb-4 mr-2"
            target="_blank"
          >
            Important College Updates
          </a>
          <a
            href="https://t.me/vitx_all"
            target="_blank"
            className="button is-info mb-4 mr-2"
          >
            <span className="icon is-small">
              <i className="fab fa-telegram-plane" />
            </span>
            <span>Join our Telegram Group</span>
          </a>
          <a
            href={WHATSAPP_SHARE_LINK}
            target="_blank"
            className="button is-success mb-4 mr-2"
          >
            <span className="icon is-small">
              <i className="fab fa-whatsapp" />
            </span>
            <span>Share on WhatsApp</span>
          </a>

          <input
            className="input"
            value={userSearchInput}
            placeholder="Search with course name or faculty name"
            onChange={e => {
              updateUserSearchInput(e.target.value)
            }}
          />
        </div>
        <div className="columns is-multiline">
          {groups?.length === 0 && <p className="ml-3">Loading...</p>}
          {groups?.length !== 0 && filteredGroups?.length === 0 && (
            <div className="container has-text-centered">
              <h3 className="is-size-3 mb-4">No results found!</h3>
              <a
                href="https://go.vitspot.com/f19"
                className="button is-primary has-text-white mb-4"
                target="_blank"
              >
                Add Your Group
              </a>
            </div>
          )}
          {filteredGroups
            .slice(0, MAX_SEARCH_RESULTS)
            .map(
              ({ campus, courseName, facultyName, slot, whatsappGroupUrl }) => (
                <div
                  className="column is-one-third-desktop is-half-tablet"
                  key={v4()}
                >
                  <div className="card has-text-centered">
                    <div className="card-content">
                      <div className="content">
                        <p className="title">{courseName}</p>
                        <p className="subtitle">{facultyName}</p>
                        <a
                          href={whatsappGroupUrl}
                          className="mt-2 button is-primary has-text-white"
                          target="_blank"
                        >
                          Join
                        </a>{" "}
                        <a
                          href="https://go.vitspot.com/f19"
                          className="mt-2 button is-dark has-text-white"
                          target="_blank"
                        >
                          Add Your Group
                        </a>
                      </div>
                    </div>
                    <footer className="card-footer">
                      <p className="card-footer-item">{slot}</p>
                      <p className="card-footer-item">{campus}</p>
                    </footer>
                  </div>
                </div>
              )
            )}
        </div>
      </div>
    </>
  )
}

export default ClassGroups
